// Bloqueia ações durante a personificação apenas em produção; fora dela fica liberado para testes.
export const isImpersonationLocked = () =>
    process.env.NODE_ENV === "production" && localStorage.getItem("impersonating") === "true";
